import pigImg from './assets/pig.svg';
import pigMobileImg from './assets/pig_mobile.svg';
import keyImg from './assets/key.svg';
import keyMobileImg from './assets/key_mobile.svg';
import houseImg from './assets/house.svg';
import houseMobileImg from './assets/house_mobile.svg';
import { useIsDesktop } from '@cian/valuation-utils-component';

export function useGetAdvantagesContent() {
  const isDesktop = useIsDesktop();

  return [
    {
      title: <>Определиться {isDesktop && <br />} с будущим</>,
      text: 'Узнайте, за сколько и как быстро можно продать жильё — и какое подойдёт взамен',
      imgUrl: isDesktop ? pigImg : pigMobileImg,
      className: 'pig',
    },
    {
      title: <>Сдать квартиру {isDesktop && <br />} выгодно</>,
      text: 'Доход от аренды, спрос на рынке — знаем всё, что полезно собственникам',
      imgUrl: isDesktop ? keyImg : keyMobileImg,
      className: 'key',
    },
    {
      title: 'Решить, что делать с загородным жильём',
      text: 'Трехэтажный особняк, бабушкина дача или участок — расскажем обо всём',
      imgUrl: isDesktop ? houseImg : houseMobileImg,
      className: 'house',
    },
  ];
}
